import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import axiosInstance from '../utils/axiosInstance'
import ProductCard from './ProductCard'
import { useTranslation } from 'react-i18next'
import { useMoney } from '../stores/currenciesStore'

const TrendingOne = () => {
    const [trendingProducts, setTrendingProducts] = useState([])
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)
    const [activeCategory, setActiveCategory] = useState('all')
    const { t } = useTranslation()
    const { money } = useMoney()

    useEffect(() => {
        const fetchTrendingProducts = async () => {
            setLoading(true)
            setError(null)
            try {
                const response = await axiosInstance.get('/api/metrics/products/trending')
                // Handle different possible response structures
                const products = response.data.data || response.data || []
                setTrendingProducts(products)
            } catch (err) {
                console.error('Error fetching trending products:', err)
                setError(err.message || 'Failed to fetch trending products')
            } finally {
                setLoading(false)
            }
        }

        fetchTrendingProducts()
    }, [])

    // Filter products based on active category
    const getFilteredProducts = () => {
        if (activeCategory === 'all') {
            return trendingProducts;
        }
        
        return trendingProducts.filter(product => 
            product.category?.toLowerCase() === activeCategory.toLowerCase());
    }

    const filteredProducts = getFilteredProducts();

    // Separate render functions for different states
    const renderLoading = () => (
        <div className="py-5 text-center">
            <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">{t('common.loading')}</span>
            </div>
        </div>
    );

    const renderError = () => (
        <div className="text-center alert alert-danger" role="alert">
            {error}
        </div>
    );

    const renderEmptyState = () => (
        <div className="py-4 text-center">
            <p>{t('home.no_trending_products')}</p>
        </div>
    );

    const renderProductsList = () => (
        <div className="row g-12">
            {filteredProducts.map((product) => (
                <div className="col-xxl-2 col-xl-3 col-lg-4 col-sm-6" key={product.id}>
                    <ProductCard 
                        product={product} 
                        badgeText={t('home.trending')}
                        badgeColor="bg-tertiary-600"
                    />
                </div>
            ))}
        </div>
    );

    // Determine which content to render
    const renderContent = () => {
        if (loading) {
            return renderLoading();
        }
        
        if (error) {
            return renderError();
        }

        console.log(filteredProducts, 'filteredProducts')
        
        if (filteredProducts.length === 0) {
            return renderEmptyState();
        }
        
        return renderProductsList();
    };

    return (
        <section className="trending-productss tw-pt-8 xl:tw-pt-16">
            <div className="container container-lg">
                <div className="p-24 border border-gray-100 rounded-16">
                    <div className="mb-24 section-heading">
                        <div className="flex-wrap gap-8 flex-between">
                            <h5 className="mb-0">{t('home.trending_products')}</h5>
                        </div>
                    </div>
                    <div className="tab-content">
                        {renderContent()}
                    </div>
                </div>
            </div>
        </section>
    )
}

export default TrendingOne